var cards = {
    methods: {

        /*
         *  Returns the colour class from the card suit
         *  @param {string} suit - The card suit
         */
        getCardColor(suit) {
            var color;
            switch (suit) {
                case 'spades':
                    color = 'text-suit-black';
                    break;
                case 'diamonds':
                    color = 'text-suit-red';
                    break;
                case 'clubs':
                    color = 'text-suit-black';
                    break;
                case 'hearts':
                    color = 'text-suit-red';
                    break;
            }
            return color;
        },

        /*
         *  Returns the card suit emoji from the card suit
         *  @param {string} suit - The card suit
         */
        getCardSuit(suit) {
            var character;
            switch (suit) {
                case 'spades':
                    character = '♠️';
                    break;
                case 'diamonds':
                    character = '♦️';
                    break;
                case 'clubs':
                    character = '♣️';
                    break;
                case 'hearts':
                    character = '♥️';
                    break;
            }
            return character;
        },

        /*
         *  Returns the card value character from the card value
         *  @param {string} value - The card value
         */
        getCardValue(value) {
            var character;
            switch (value) {
                case 'one':
                    character = 1;
                    break;
                case 'two':
                    character = 2;
                    break;
                case 'three':
                    character = 3;
                    break;
                case 'four':
                    character = 4;
                    break;
                case 'five':
                    character = 5;
                    break;
                case 'six':
                    character = 6;
                    break;
                case 'seven':
                    character = 7;
                    break;
                case 'eight':
                    character = 8;
                    break;
                case 'nine':
                    character = 9;
                    break;
                case 'ten':
                    character = 10;
                    break;
                case 'jack':
                    character = 'J';
                    break;
                case 'queen':
                    character = 'Q';
                    break;
                case 'king':
                    character = 'K';
                    break;
                case 'ace':
                    character = 'A';
                    break;
            }
            return character;
        },

    }
}

export default cards;
